import React, { PureComponent, PropTypes } from 'react';
import DocumentTitle from 'react-document-title';
import { NavLink } from 'react-router-dom';

import { connect } from 'react-redux';
import { Redirect } from 'react-router';
import { logIn } from '../../redux/actions';
import Alert from '../../components/Form/Alert';
import classNames from 'classnames';

class Login extends PureComponent {
  static propTypes = {
    loginErrors: PropTypes.object.isRequired,
    user: PropTypes.object,
  };

  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleSubmit(e) {
    e.preventDefault();

    this.props.logIn(
      this.email.value,
      this.password.value
    );
  }

  render() {
    const { location: { query: { next } }, user, loginErrors: { nonFieldErrors, password, username } } = this.props;

    if (user) {
      if (next)  {
        return <Redirect to={next}/>
      }
      return <Redirect to="/"/>
    }

    return (
      <div className="container mt-5">
        <DocumentTitle title="Autorizācija - e-BML" />
        <h1>Autorizēties</h1>
        <div className="row">
          <form className="mt-3 col-lg-7" onSubmit={this.handleSubmit} noValidate>
            {nonFieldErrors && <Alert>{nonFieldErrors}</Alert>}
            <div className={classNames("form-group row", { 'has-danger': username })}>
              <label htmlFor="email" className="col-sm-3 col-form-label col-form-label-lg">
                E-pasts
              </label>
              <div className="col-sm-9">
                <input
                  type="email"
                  className={classNames("form-control form-control-lg", {"form-control-danger": username})}
                  id="email"
                  ref={r => this.email = r}
                />
                { username && <div className="form-control-feedback">{username}</div> }
              </div>
            </div>
            <div className={classNames("form-group row", { 'has-danger': password })}>
              <label htmlFor="password" className="col-sm-3 col-form-label col-form-label-lg">
                Parole
              </label>
              <div className="col-sm-9">
                <input
                  type="password"
                  className={classNames("form-control form-control-lg", {"form-control-danger": password})}
                  id="password"
                  ref={r => this.password = r}
                />
                { password && <div className="form-control-feedback">{password}</div> }
              </div>
            </div>
            <div className="form-group row">
              <div className="col-sm-9 offset-sm-3">
                <button className="btn btn-primary btn-lg">
                  Autorizēties
                </button>
                <NavLink className="btn btn-link" to="/registration">Reģistrēties</NavLink>
                <NavLink className="btn btn-link" to="/reset/request">Mainīt paroli</NavLink>
              </div>
            </div>
          </form>
        </div>
      </div>
    )
  }
};

const mapStateToProps = (state, props) => state.user;

export default connect(mapStateToProps, {logIn})(Login);




// WEBPACK FOOTER //
// ./src/scenes/Login/index.js